<ng-container *ngIf="containerClass; else noContainer">
    <!-- Flex container to keep paginator at bottom -->
    <div class="flex flex-col h-full gap-2" [class]="containerClass">
        <!-- Scrollable grid content -->
        <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
            <div class="grid" [ngClass]="getGridClasses()">
                <ng-container *ngFor="let item of paginatedItems">
                    <div class="min-w-0 w-full">
                        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Paginator fixed at bottom -->
        <div class="flex-shrink-0" *ngIf="shouldShowPaginator">
            <p-paginator [rows]="rows" [totalRecords]="displayTotalRecords" [rowsPerPageOptions]="rowsPerPageOptions"
                [first]="internalFirst" (onPageChange)="onPageChange($event)">
            </p-paginator>
        </div>
    </div>
</ng-container>

<ng-template #noContainer>
    <!-- Flex container to keep paginator at bottom -->
    <div class="flex flex-col h-full gap-2">
        <!-- Scrollable grid content -->
        <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
            <div class="grid" [ngClass]="getGridClasses()">
                <ng-container *ngFor="let item of paginatedItems">
                    <div class="min-w-0 w-full">
                        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Paginator fixed at bottom -->
        <div class="flex-shrink-0" *ngIf="shouldShowPaginator">
            <p-paginator [rows]="rows" [totalRecords]="displayTotalRecords" [rowsPerPageOptions]="rowsPerPageOptions"
                [first]="internalFirst" (onPageChange)="onPageChange($event)">
            </p-paginator>
        </div>
    </div>
</ng-template>
